export const GET_PAYMENT_STATUS_MESSAGE_REQUEST =
  "GET_PAYMENT_STATUS_MESSAGE_REQUEST";
export const GET_PAYMENT_STATUS_MESSAGE_SUCCESS =
  "GET_PAYMENT_STATUS_MESSAGE_SUCCESS";
export const GET_PAYMENT_STATUS_MESSAGE_FAILURE =
  "GET_PAYMENT_STATUS_MESSAGE_FAILURE";
//LiveChat
export const GET_CHAT_CONFIGURATION = "GET_CHAT_CONFIGURATION";
export const GET_CHAT_CONFIGURATION_SUCCESS = "GET_CHAT_CONFIGURATION_SUCCESS";
export const GET_CHAT_CONFIGURATION_FAILURE = "GET_CHAT_CONFIGURATION_FAILURE";

export const GET_CREATE_CHAT = "GET_CREATE_CHAT";
export const GET_CREATE_CHAT_SUCCESS = "GET_CREATE_CHAT_SUCCESS";
export const GET_CREATE_CHAT_FAILURE = "GET_CREATE_CHAT_FAILURE";

export const GET_CHAT_UPDATE = "GET_CHAT_UPDATE";
export const GET_CHAT_UPDATE_SUCCESS = "GET_CHAT_UPDATE_SUCCESS";
export const GET_CHAT_UPDATE_FAILURE = "GET_CHAT_UPDATE_FAILURE";

export const GET_CHAT_MESSAGE = "GET_CHAT_MESSAGE";
export const GET_CHAT_MESSAGE_SUCCESS = "GET_CHAT_MESSAGE_SUCCESS";
export const GET_CHAT_MESSAGE_FAILURE = "GET_CHAT_MESSAGE_FAILURE";

export const GET_CREATE_MESSAGE = "GET_CREATE_MESSAGE";
export const GET_CREATE_MESSAGE_SUCCESS = "GET_CREATE_MESSAGE_SUCCESS";
export const GET_CREATE_MESSAGE_FAILURE = "GET_CREATE_MESSAGE_FAILURE";

export const GET_TWILIO_QUIT_QUEUE = "GET_TWILIO_QUIT_QUEUE";
export const GET_TWILIO_QUIT_QUEUE_SUCCESS = "GET_TWILIO_QUIT_QUEUE_SUCCESS";
export const GET_TWILIO_QUIT_QUEUE_FAILURE = "GET_TWILIO_QUIT_QUEUE_FAILURE";

export const GET_SCHEDULE_CALL_BACK = "GET_SCHEDULE_CALL_BACK";
export const GET_SCHEDULE_CALL_BACK_SUCCESS = "GET_SCHEDULE_CALL_BACK_SUCCESS";
export const GET_SCHEDULE_CALL_BACK_FAILURE = "GET_SCHEDULE_CALL_BACK_FAILURE";

export const GET_DISABLED_TIME_LISTS = "GET_DISABLED_TIME_LISTS";
export const GET_DISABLED_TIME_LISTS_SUCCESS =
  "GET_DISABLED_TIME_LISTS_SUCCESS";
export const GET_DISABLED_TIME_LISTS_FAILURE =
  "GET_DISABLED_TIME_LISTS_FAILURE";

export const CREATE_APPOINTMENT = "CREATE_APPOINTMENT";
export const CREATE_APPOINTMENT_SUCCESS = "CREATE_APPOINTMENT_SUCCESS";
export const CREATE_APPOINTMENT_FAILURE = "CREATE_APPOINTMENT_FAILURE";

export const GET_PROFILE_LIST_REQUEST = "GET_PROFILE_LIST_REQUEST";
export const GET_PROFILE_LIST_SUCCESS = "GET_PROFILE_LIST_SUCCESS";
export const GET_PROFILE_LIST_FAILURE = "GET_PROFILE_LIST_FAILURE";

export const GET_CHAT_REPLY_STATUS = "GET_CHAT_REPLY_STATUS";
export const GET_CHAT_REPLY_STATUS_SUCCESS = "GET_CHAT_REPLY_STATUS_SUCCESS";
export const GET_CHAT_REPLY_STATUS_FAILURE = "GET_CHAT_REPLY_STATUS_FAILURE";

export const CONNECT_LIVE_CHAT = "CONNECT_LIVE_CHAT";
export const CONNECT_LIVE_CHAT_SUCCESS = "CONNECT_LIVE_CHAT_SUCCESS";
export const CONNECT_LIVE_CHAT_FAILURE = "CONNECT_LIVE_CHAT_FAILURE";

export const GET_INSIDER_CLIENT_INFO_REQUEST =
  "GET_INSIDER_CLIENT_INFO_REQUEST";
export const GET_INSIDER_CLIENT_INFO_SUCCESS =
  "GET_INSIDER_CLIENT_INFO_SUCCESS";
export const GET_INSIDER_CLIENT_INFO_FAILURE =
  "GET_INSIDER_CLIENT_INFO_FAILURE";

export const SINGTEL_PARTNERSHIP_LEADS_REQ = "SINGTEL_PARTNERSHIP_LEADS_REQ";
export const SINGTEL_PARTNERSHIP_LEADS_REQ_SUCCESS =
  "SINGTEL_PARTNERSHIP_LEADS_REQ_SUCCESS";
export const SINGTEL_PARTNERSHIP_LEADS_REQ_FAILURE =
  "SINGTEL_PARTNERSHIP_LEADS_REQ_FAILURE";

export const getPaymentStatusMessageRequest = (Id) => ({
  type: "GET_PAYMENT_STATUS_MESSAGE_REQUEST",
  Id,
});

export const getPaymentStatusMessageSuccess = (data) => ({
  type: "GET_PAYMENT_STATUS_MESSAGE_SUCCESS",
  data,
});

export const getPaymentStatusMessageFailure = (message) => ({
  type: "GET_PAYMENT_STATUS_MESSAGE_FAILURE",
  message,
});

//Live Chat
export const getChatConfiguration = () => ({
  type: "GET_CHAT_CONFIGURATION",
});

export const getChatConfigurationSuccess = (data) => ({
  type: "GET_CHAT_CONFIGURATION_SUCCESS",
  data,
});

export const getChatConfigurationFailure = (message) => ({
  type: "GET_CHAT_CONFIGURATION_FAILURE",
  message,
});

export const getCreateChat = (sessionId) => ({
  type: "GET_CREATE_CHAT",
  sessionId,
});

export const getCreateChatSuccess = (data) => ({
  type: "GET_CREATE_CHAT_SUCCESS",
  data,
});

export const getCreateChatFailure = (message) => ({
  type: "GET_CREATE_CHAT_FAILURE",
  message,
});

export const getChatUpdate = (threadID, loginId) => ({
  type: "GET_CHAT_UPDATE",
  threadID,
  loginId,
});

export const getChatUpdateSuccess = (data) => ({
  type: "GET_CHAT_UPDATE_SUCCESS",
  data,
});

export const getChatUpdateFailure = (message) => ({
  type: "GET_CHAT_UPDATE_FAILURE",
  message,
});

export const getChatMessage = (threadID, loginId) => ({
  type: "GET_CHAT_MESSAGE",
  threadID,
  loginId,
});

export const getChatMessageSuccess = (data) => ({
  type: "GET_CHAT_MESSAGE_SUCCESS",
  data,
});

export const getChatMessageFailure = (message) => ({
  type: "GET_CHAT_MESSAGE_FAILURE",
  message,
});

export const getCreateMessage = (
  threadID,
  content,
  messageType,
  payload,
  attachedFiles,
  intent,
  level,
  loginId
) => ({
  type: "GET_CREATE_MESSAGE",
  threadID,
  content,
  messageType,
  payload,
  attachedFiles,
  intent,
  level,
  loginId,
});

export const getCreateMessageSuccess = (data) => ({
  type: "GET_CREATE_MESSAGE_SUCCESS",
  data,
});

export const getCreateMessageFailure = (message) => ({
  type: "GET_CREATE_MESSAGE_FAILURE",
  message,
});

export const getTwilioQuitQueue = (threadID) => ({
  type: "GET_TWILIO_QUIT_QUEUE",
  threadID,
});

export const getTwilioQuitQueueSuccess = (data) => ({
  type: "GET_TWILIO_QUIT_QUEUE_SUCCESS",
  data,
});

export const getTwilioQuitQueueFailure = (message) => ({
  type: "GET_TWILIO_QUIT_QUEUE_FAILURE",
  message,
});

export const getScheduleCallBack = (threadID) => ({
  type: "GET_SCHEDULE_CALL_BACK",
  threadID,
});

export const getScheduleCallBackSuccess = (data) => ({
  type: "GET_SCHEDULE_CALL_BACK_SUCCESS",
  data,
});

export const getScheduleCallBackFailure = (message) => ({
  type: "GET_SCHEDULE_CALL_BACK_FAILURE",
  message,
});

export const getDisabledTimeLists = (date) => ({
  type: "GET_DISABLED_TIME_LISTS",
  date,
});

export const getDisabledTimeListsSuccess = (data) => ({
  type: "GET_DISABLED_TIME_LISTS_SUCCESS",
  data,
});

export const getDisabledTimeListsFailure = (message) => ({
  type: "GET_DISABLED_TIME_LISTS_FAILURE",
  message,
});

export const createAppointment = (
  threadID,
  bookSTime,
  bookETime,
  customerN,
  email,
  mobile
) => ({
  type: "CREATE_APPOINTMENT",
  threadID,
  bookSTime,
  bookETime,
  customerN,
  email,
  mobile,
});

export const createAppointmentSuccess = (data) => ({
  type: "CREATE_APPOINTMENT_SUCCESS",
  data,
});

export const createAppointmentFailure = (message) => ({
  type: "CREATE_APPOINTMENT_FAILURE",
  message,
});

//Get Profile Info
export const getProfileListRequest = (nric) => ({
  type: "GET_PROFILE_LIST_REQUEST",
  nric,
});
export const getProfileListSuccess = (data) => ({
  type: "GET_PROFILE_LIST_SUCCESS",
  data,
});
export const getProfileListFailure = (message) => ({
  type: "GET_PROFILE_LIST_FAILURE",
  message,
});

export const getChatReplyStatus = (chatid, feedbackStatus) => ({
  type: "GET_CHAT_REPLY_STATUS",
  chatid,
  feedbackStatus,
});

export const getChatReplyStatusSuccess = (data) => ({
  type: "GET_CHAT_REPLY_STATUS_SUCCESS",
  data,
});

export const getChatReplyStatusFailure = (message) => ({
  type: "GET_CHAT_REPLY_STATUS_FAILURE",
  message,
});
//connect live chat
export const connectLiveChat = (threadID) => ({
  type: "CONNECT_LIVE_CHAT",
  threadID,
});

export const connectLiveChatSuccess = (data) => ({
  type: "CONNECT_LIVE_CHAT_SUCCESS",
  data,
});

export const connectLiveChatFailure = (message) => ({
  type: "CONNECT_LIVE_CHAT_FAILURE",
  message,
});

//Get Insider ClientInfo
export const getInsiderClientInfoReq = () => ({
  type: "GET_INSIDER_CLIENT_INFO_REQUEST",
});
export const getInsiderClientInfoReqSuccess = (data) => ({
  type: "GET_INSIDER_CLIENT_INFO_SUCCESS",
  data,
});
export const getInsiderClientInfoReqFailure = (message) => ({
  type: "GET_INSIDER_CLIENT_INFO_FAILURE",
  message,
});

//singtelPartnershipLeadsReq
export const singtelPartnershipLeadsReq = (submitData) => ({
  type: "SINGTEL_PARTNERSHIP_LEADS_REQ",
  submitData,
});
export const singtelPartnershipLeadsReqSuccess = (data) => ({
  type: "SINGTEL_PARTNERSHIP_LEADS_REQ_SUCCESS",
  data,
});
export const singtelPartnershipLeadsReqFailure = (message) => ({
  type: "SINGTEL_PARTNERSHIP_LEADS_REQ_FAILURE",
  message,
});
